import { css } from '@huspy/styled-system/css';

const commissionBannerStyles = {
  container: css({
    paddingY: 5,
    paddingX: 8,
    borderRadius: 5,
    background: '#eef3f7',
    width: '100%',
  }),
  commission: css({
    background: '-webkit-linear-gradient(#0E4160, #4A7E8F)',
    WebkitTextFillColor: 'transparent',
  }),
  stepsContainer: css({
    borderRadius: 2,
    background: 'white',
    paddingY: 4,
    paddingX: 5,
  }),
};

export default commissionBannerStyles;
